

export const API_GATEWAY_NAME = "CubexApiGateWay"